import { ClackSkuConfig } from '../models/clack-data.model';

export function isValidClackSkuConfig(config: ClackSkuConfig): boolean {
  const { minimumQuantity, maximumQuantity, minimumTaskQuantity } = config;

  return (
    !!config.sku.trim() &&
    Number.isInteger(minimumQuantity) &&
    Number.isInteger(maximumQuantity) &&
    Number.isInteger(minimumTaskQuantity) &&
    (minimumQuantity ?? -1) >= 0 &&
    (maximumQuantity ?? -1) >= (minimumQuantity ?? 0) &&
    (minimumTaskQuantity ?? 0) > 0
  );
}

export function calculateClackTaskQuantity(
  config: ClackSkuConfig,
  groceryQuantity: number,
  openTaskQuantity: number
): number {
  if (!isValidClackSkuConfig(config)) {
    return 0;
  }

  const projectedQuantity =
    Math.max(0, groceryQuantity) + Math.max(0, openTaskQuantity);
  const minimumQuantity = config.minimumQuantity as number;
  const maximumQuantity = config.maximumQuantity as number;
  const minimumTaskQuantity = config.minimumTaskQuantity as number;

  if (projectedQuantity >= minimumQuantity) {
    return 0;
  }

  return Math.ceil(
    Math.max(maximumQuantity - projectedQuantity, minimumTaskQuantity)
  );
}
